import React, { useState } from "react";
import { useNavigate } from "react-router";
import "./SignUp.css";

function SignUp() {
  const [formData, setFormData] = useState({});

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({
      ...formData,
      [id]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // console.log(formData);
    localStorage.setItem("signup", JSON.stringify(formData));
    alert("Signup Successfull");
    navigate("/login");
  };
  return (
    <div>
      <div id="container">
        <h1 class="bold">Create an account</h1>
        <p class="grey">* Indicates required field</p>
        <form onSubmit={handleSubmit}>
          <div id="p1">
            <div class="first">
              <p>First Name*</p>
              <input
                id="name"
                type="text"
                placeholder="First name here"
                onChange={handleChange}
              />
            </div>
            <div class="second">
              <p>Last Name*</p>
              <input
                id="lastname"
                type="text"
                placeholder="Last name here"
                onChange={handleChange}
              />
            </div>
          </div>
          <p>Email address*</p>
          <input
            id="email"
            type="email"
            placeholder="yourname@example.com"
            onChange={handleChange}
          />
          <div id="p2">
            <div class="third">
              <p>Password*</p>
              <input
                id="pass"
                type="password"
                placeholder="Please enter your password"
                onChange={handleChange}
              />
            </div>
            <div class="fourth">
              <p>Confirm password*</p>
              <input
                id="confirmpass"
                type="password"
                placeholder="Please re-enter your password"
                onChange={handleChange}
              />
            </div>
          </div>
          <p>Enter a mobile number</p>
          <input
            id="mobile"
            type="number"
            placeholder="Please enter your 10 digit mobile number"
            onChange={handleChange}
          />
          <br />
          <input id="btn" type="submit" value="Create your new account" />
        </form>
      </div>
    </div>
  );
}

export default SignUp;
